import { color } from '@upstox/upstox-ui';

export const container: CSSFunction = () => ({
  flexDirection: 'column',
  alignItems: 'center',
  padding: '16px',
  width: '100%',
  gap: '8px',
});

export const title: CSSFunction = ({ theme }) => ({
  fontSize: '16px',
  fontWeight: theme.fontWeights.bold,
  color: color(theme, 'text.1'),
});

export const subtitle: CSSFunction = ({ theme }) => ({
  fontSize: '13px',
  fontWeight: theme.fontWeights.normal,
  color: color(theme, 'text.2'),
});
